import { Tag } from '@chakra-ui/react';

export const AccountPartnerBadge = () => (
  <Tag.Root variant="blue" ml="2">
    Partner
  </Tag.Root>
);
